import { B2BContentPageViewModel } from '@/types/B2BcontentServerContract';
import httpService from '@/core/http/http.service';
import { B2CContentPageViewModel, B2CPublicContentPageViewModel } from '@/types/B2CcontentServerContract';
import Deferred from '@/core/async/Deferred';
import { hardReload } from '@/core/navigation/redirect.service';

export const WINDOW_PAGE_CONTENT_PROPERTY = '$$initialPageViewModel$$';

class ContentApiService {
    private serverContextStateKey: string | null = null;
    private siteContextStateKey: string | null = null;

    async getPage(relativeUrl: string, initialPageLoad: boolean = false): Promise<B2BContentPageViewModel | B2CContentPageViewModel | B2CPublicContentPageViewModel> {
        const deferred = new Deferred<B2BContentPageViewModel | B2CContentPageViewModel | B2CPublicContentPageViewModel>();
        const initialPageViewModel: B2BContentPageViewModel | B2CContentPageViewModel | B2CPublicContentPageViewModel | null = window[WINDOW_PAGE_CONTENT_PROPERTY];
        if (initialPageLoad && initialPageViewModel) {
            this.serverContextStateKey = initialPageViewModel.serverContextStateKey;
            deferred.resolve(initialPageViewModel);
        } else {
            try {
                const pageViewModel = await httpService.getPage(relativeUrl);
                this.reloadIfServerContextStateKeyMismatch(pageViewModel.serverContextStateKey);
                this.updateSiteContextIfStateKeyMismatch(pageViewModel.siteContextStateKey);
                deferred.resolve(pageViewModel);
            } catch (error) {
                deferred.reject(error);
            }
        }
        return deferred.promise;
    }

    private reloadIfServerContextStateKeyMismatch(key: string): void {
        this.serverContextStateKey && key !== this.serverContextStateKey && hardReload();
    }

    private updateSiteContextIfStateKeyMismatch(key: string): void {
        if (this.siteContextStateKey && key !== this.siteContextStateKey) {
            // TODO: Fetch update for siteContext
        }
    }
}

export default new ContentApiService();
